import { ReviewType } from 'src/app/helpers/enums/settings/review-type/reviewType';

export const ReviewTypeDetails = new Map<number, string>([
    [ReviewType.ManualCreateAsNeeded, 'Manual: Create As Needed'],
    [ReviewType.AutoGenerateOnePerCase, 'Auto-Generate: 1 Per Case'],
    [ReviewType.AutoGenerateOnePerCaseAssignment, 'Auto-Generate: 1 Per Case Assignment'],
    [ReviewType.AutoGenerateOnePerTaskOrAssigment, 'Auto-Generate: 1 Per Task/Event Assignment']
  ]);
